function registerInClinicGiftCardWizard() {
  if (!window.Alpine || window.__inClinicGiftCardWizardRegistered) return;

  window.__inClinicGiftCardWizardRegistered = true;

  window.Alpine.data('inClinicGiftCardWizard', (config = {}) => ({
    step: 1,
    error: '',
    minDate: config.minDate || '',
    recipientType: 'A Friend',
    recipientName: '',
    senderName: '',
    buyerName: '',
    message: '',
    recipientEmail: '',
    confirmEmail: '',
    deliveryDate: '',
    quantity: 1,

    selectedVariantId: String(config.initialVariantId || ''),
    selectedVariantTitle: config.initialVariantTitle || '',
    selectedVariantPrice: config.initialVariantPrice || '',
    selectedDesignLabel: config.initialDesignLabel || '',
    selectedDesignImage: config.initialDesignImage || '',

    get emailLabel() {
      if (this.recipientType === 'A Friend') {
        return this.recipientName ? `${this.recipientName}'s email` : 'Recipient email';
      }
      return 'Your email';
    },

    goTo(stepNumber) {
      this.error = '';
      this.step = stepNumber;
    },

    nextFromStep1() {
      this.error = '';

      if (this.recipientType === 'A Friend') {
        if (!this.recipientName.trim()) {
          this.error = 'Please enter their name.';
          return;
        }
        if (!this.senderName.trim()) {
          this.error = 'Please enter your name.';
          return;
        }
      }

      if (this.recipientType === 'For Me') {
        if (!this.buyerName.trim()) {
          this.error = 'Please enter your name.';
          return;
        }
      }

      this.step = 2;
    },

    nextFromStep2() {
      this.error = '';

      if (!this.selectedDesignLabel) {
        this.error = 'Please choose a gift card design.';
        return;
      }

      this.step = 3;
    },

    nextFromStep3() {
      this.error = '';

      if (!this.selectedVariantId) {
        this.error = 'Please choose an amount.';
        return;
      }

      if (this.quantity < 1) {
        this.error = 'Quantity must be at least 1.';
        return;
      }

      this.step = 4;
    },

    selectDesign(label, image) {
      this.selectedDesignLabel = label;
      this.selectedDesignImage = image;
      this.error = '';
    },

    selectVariant(id, title, price) {
      this.selectedVariantId = String(id);
      this.selectedVariantTitle = title;
      this.selectedVariantPrice = price;
      this.error = '';
    },

    increaseQty() {
      this.quantity += 1;
      this.error = '';
    },

    decreaseQty() {
      if (this.quantity > 1) {
        this.quantity -= 1;
      }
      this.error = '';
    },

    isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },

    validateAndSubmit(event) {
      this.error = '';

      if (!this.recipientEmail.trim()) {
        this.error = 'Please enter an email address.';
        event.preventDefault();
        return;
      }

      if (!this.isValidEmail(this.recipientEmail.trim())) {
        this.error = 'Please enter a valid email address.';
        event.preventDefault();
        return;
      }

      if (!this.confirmEmail.trim()) {
        this.error = 'Please confirm the email address.';
        event.preventDefault();
        return;
      }

      if (this.recipientEmail.trim().toLowerCase() !== this.confirmEmail.trim().toLowerCase()) {
        this.error = 'Email addresses do not match.';
        event.preventDefault();
        return;
      }

      if (this.deliveryDate && this.minDate && this.deliveryDate < this.minDate) {
        this.error = 'Delivery date cannot be in the past.';
        event.preventDefault();
      }
    }
  }));

  const roots = document.querySelectorAll('[x-data*="inClinicGiftCardWizard"]');
  roots.forEach((root) => {
    if (!root.__icgcInitialized) {
      root.__icgcInitialized = true;
      window.Alpine.initTree(root);
    }
  });
}

if (window.Alpine) {
  registerInClinicGiftCardWizard();
} else {
  document.addEventListener('alpine:init', registerInClinicGiftCardWizard);
}